import { mapGetters, mapMutations } from 'vuex'
import { PopupName } from '@/store/modules/popups'
// country-modal is on the critical render path: for a first-time visitor the
// whole app is gated behind `isCountrySelected`, so this modal IS the first
// meaningful paint. It must stay eager (NOT in the lazy popups chunk).
import countryModal from '../country-modal/index.vue'

// The remaining popups are rendered only behind v-if (opened on user action),
// so they are loaded lazily as async components — this keeps them (and their
// heavy form / phone-input dependencies) out of the initial bundle. They share
// one "popups" chunk that is fetched on the first modal open.
const login = () => import(/* webpackChunkName: "popups" */ '../popups/login/index.vue')
const registration = () => import(/* webpackChunkName: "popups" */ '../popups/registration/index.vue')
const reset = () => import(/* webpackChunkName: "popups" */ '../popups/reset/index.vue')
const restore = () => import(/* webpackChunkName: "popups" */ '../popups/restore/index.vue')
const addressesList = () => import(/* webpackChunkName: "popups" */ '../popups/addresses-list/index.vue')
const instagramPost = () => import(/* webpackChunkName: "popups" */ '../popups/instagram-post/index.vue')
const successRegister = () => import(/* webpackChunkName: "popups" */ '../popups/success-register/index.vue')
const anotherCosmetolog = () => import(/* webpackChunkName: "popups" */ '../popups/activate-another-cosmetolog/index.vue')
const fastBuy = () => import(/* webpackChunkName: "popups" */ '../popups/fast-buy/index.vue')
const defaultPrices = () => import(/* webpackChunkName: "popups" */ '../popups/default-prices/index.vue')
const formApplication = () => import(/* webpackChunkName: "popups" */ '../popups/form-application/index.vue')
const paymentInfo = () => import(/* webpackChunkName: "popups" */ '../popups/payment-info/index.vue')
const successRegisterAgent = () => import(/* webpackChunkName: "popups" */ '../popups/successRegisterAgent/index.vue')
const successRegisterAgentDiscount = () => import(/* webpackChunkName: "popups" */ '../popups/successRegisterAgentDiscount/index.vue')
const seminarRegistration = () => import(/* webpackChunkName: "popups" */ '@/components/popups/seminar-registration/index.vue')
const successRegisterSeminar = () => import(/* webpackChunkName: "popups" */ '@/components/popups/succes-seminar-register/index.vue')
const agentRegister = () => import(/* webpackChunkName: "popups" */ '@/components/popups/agent-register/index.vue')
const otherRegister = () => import(/* webpackChunkName: "popups" */ '@/components/popups/other-register/index.vue')
const successOrder = () => import(/* webpackChunkName: "popups" */ '@/components/popups/success-order/index.vue')
const basket = () => import(/* webpackChunkName: "popups" */ '@/components/popups/basket/index.vue')
const seminarDetails = () => import(/* webpackChunkName: "popups" */ '@/components/popups/seminar-details/index.vue')
const seminarInfo = () => import(/* webpackChunkName: "popups" */ '@/components/popups/seminar-info/index.vue')
const notifyWhenAvailable = () => import(/* webpackChunkName: "popups" */ '@/components/popups/notify-when-available/index.vue')
const smsPopup = () => import(/* webpackChunkName: "popups" */ '@/components/popups/sms-popup/index.vue')
const distributorRegister = () => import(/* webpackChunkName: "popups" */ '@/components/popups/distributor-register/index.vue')
const remainings = () => import(/* webpackChunkName: "popups" */ '../popups/remainings/index.vue')
const metodistPopup = () => import(/* webpackChunkName: "popups" */ '../metodist-popup/index.vue')
const feedbackModal = () => import(/* webpackChunkName: "popups" */ '@/components/popups/feedback-modal/index.vue')
const certificateError = () => import(/* webpackChunkName: "popups" */ '../popups/certificateError/index.vue')
const reviewModal = () => import(/* webpackChunkName: "popups" */ '../popups/review-popup/index.vue')
const TextInfoModal = () => import(/* webpackChunkName: "popups" */ '../popups/text-info-modal/index.vue')
const reviewsForm = () => import(/* webpackChunkName: "popups" */ '@/components/popups/reviews-form/index.vue')
const selectGift = () => import(/* webpackChunkName: "popups" */ '@/components/popups/select-gift/index.vue')

export default {
  name: 'hidden',
  components: {
    TextInfoModal,
    login,
    registration,
    reset,
    restore,
    addressesList,
    instagramPost,
    successRegister,
    anotherCosmetolog,
    fastBuy,
    defaultPrices,
    formApplication,
    paymentInfo,
    successRegisterAgent,
    seminarRegistration,
    successRegisterSeminar,
    successRegisterAgentDiscount,
    agentRegister,
    otherRegister,
    successOrder,
    basket,
    seminarDetails,
    notifyWhenAvailable,
    smsPopup,
    feedbackModal,
    distributorRegister,
    remainings,
    seminarInfo,
    metodistPopup,
    countryModal,
    certificateError,
    reviewModal,
    reviewsForm,
    selectGift
  },
  data() {
    return {
      PopupName: PopupName,
    }
  },
  computed: {
    ...mapGetters({
      currentModal: 'popups/currentModal',
      currentModalPayload: 'popups/currentModalPayload',
      isProfessional: 'profile/isProfessional',
      isSelectGiftVisible: 'popups/isSelectGiftVisible',
      // showLangPopup: "system/showLangPopup",
    }),
  },
  methods: {
    ...mapMutations({
      closePopup: 'popups/CLOSE_POPUP',
      changeLangModal: 'system/SET_SHOW_LANG_POPUP',
      changeSelectGiftPopup: 'popups/CHANGE_SELECT_GIFT_POPUP',
    }),
    isPopupActive(name) {
      return this.currentModal === name
    },
    closeSelectGiftPopup() {
      this.changeSelectGiftPopup(false)
    },
  },
}
